/**
 * Service worker registration.
 *
 * This is what makes ZIvapp installable on a phone home screen and able to
 * open offline.
 *
 * Reminder: service workers only run over HTTPS (localhost is exempt). Over a
 * plain LAN address such as http://192.168.1.50:5173 none of this runs, which
 * is why phone testing goes through a tunnel. See docs/SETUP.md.
 */

import { registerSW } from 'virtual:pwa-register'

let updateApp = null

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return

  updateApp = registerSW({
    onNeedRefresh() {
      // A new build is waiting. Replaced by a proper prompt once the design
      // exists; a hard reload mid-conversation would be rude.
      console.info('[ZIvapp] update available — call applyUpdate() to reload')
      window.dispatchEvent(new CustomEvent('ziv:update-available'))
    },
    onOfflineReady() {
      console.info('[ZIvapp] ready to work offline')
      window.dispatchEvent(new CustomEvent('ziv:offline-ready'))
    },
    onRegisterError(error) {
      console.error('[ZIvapp] service worker registration failed:', error)
    }
  })
}

/** Activate a waiting update and reload. */
export function applyUpdate() {
  updateApp?.(true)
}
